module.exports = __webpack_public_path__ + "static/img/ymzs.f87d1d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ymzs.png
// module id = 6BO/
// module chunks = 1